import axios from 'axios';

import { CONSTANTS } from 'services';

import { DataEntity } from './shared';

class StaticContentClient {
  static async getInitialData(params = {}) {
    const { businessUnit, lang } = params;
    const data = await axios.get(
      `${CONSTANTS.serviceDomain}/content/public/static-page/menu/${businessUnit}/${lang}`,
      {
        accept: 'application/json',
      }
    );
    const items = new DataEntity(data);
    return items;
  }

  static async getContentData(params = {}) {
    const { businessUnit, lang, pageName = null } = params;
    if (pageName === null) {
      return Promise.reject(Error('page name is undefined'));
    }
    const data = await axios.get(
      `${CONSTANTS.serviceDomain}/content/public/static-page/${businessUnit}/${pageName}/${lang}`
    );
    const items = new DataEntity(data);
    return items;
  }

  static async downloadPdf(params = {}) {
    const { bu, lang, name } = params;

    const response = await axios.get(
      `${CONSTANTS.serviceDomain}/content/public/static-page/download/${bu}/${name}/${lang}`,
      {
        responseType: 'arraybuffer',
      }
    );
    const data = new DataEntity(response);
    return data;
  }

  /**
   * TODO this will return fake response for now, until theres an endpoint for the
   * available languages (These will go into the language change dropdown)
   */
  static async getLanguages() {
    const hardcoded = {
      data: [
        {
          short: 'en',
          name: 'English',
        },
        {
          short: 'bg',
          name: 'Български',
        },
      ],
    };
    const data = new DataEntity(hardcoded);
    return data;
  }
}

export default StaticContentClient;
